import { useState } from "react";

export interface Account {
  permissions: AccountPermissions;
}

export type AccountPermissions = "user" | "admin";

const testAccount: Account = {
  permissions: "admin",
};

export const useAccount = () => {
  const [account, setAccount] = useState<Account>(testAccount);

  return {
    account,
  };
};
